import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ApiService, ApiHelperService } from '../../../../shared/services';
import { Workspace } from '../../../shared/models/workspace';
import { WorkspaceUser } from '../../../shared/models/workspace-user';
import { Invitation, Role } from '../models';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class WorkspaceService {

  endpointUrl: string;

  constructor(private api: ApiService,
    { reportsServiceUrl }: ApiHelperService) {
    this.endpointUrl = `${reportsServiceUrl}/api/workspace`;
  }

  getRoles(): Observable<Role[]> {
    return this.api.get(`${this.endpointUrl}/roles`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  getWorkspaceSettings(): Observable<Workspace> {
    return this.api.get(`${this.endpointUrl}/settings`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  updateWorkspaceSettings(workspace: Workspace): Observable<Workspace> {
    return this.api.put(`${this.endpointUrl}/settings`, workspace).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  getUser(userId: string): Observable<WorkspaceUser> {
    return this.api.get(`${this.endpointUrl}/user/${userId}`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  getUsers(): Observable<WorkspaceUser[]> {
    return this.api.get(`${this.endpointUrl}/users`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  updateUser(user: WorkspaceUser): Observable<WorkspaceUser> {
    return this.api.put(`${this.endpointUrl}/user`, user).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  getWorkspace(workspaceId: string): Observable<Workspace> {
    return this.api.get(`${this.endpointUrl}/workspaces/${workspaceId}`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  getCurrentUserWorkspaces(): Observable<Workspace[]> {
    return this.api.get(`${this.endpointUrl}/workspaces`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  getInvites(): Observable<Invitation[]> {
    return this.api.get(`${this.endpointUrl}/invites`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  inviteUser(invitation: Invitation): Observable<Invitation> {
    return this.api.post(`${this.endpointUrl}/invite`, invitation).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  resendInvite(workspaceUserInvitationId: string): Observable<Invitation> {
    return this.api.put(`${this.endpointUrl}/invite/${workspaceUserInvitationId}/resend`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  revokeInvite(workspaceUserInvitationId: string): Observable<Invitation> {
    return this.api.put(`${this.endpointUrl}/invite/${workspaceUserInvitationId}/revoke`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }



  private handleError(response: HttpErrorResponse) {
    return throwError(response?.error?.errors);
  }
}
